(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid-item1"] && !Shopify.designMode) return;
  try {
    (function () {
  function labelColourLinks() {
    document.querySelectorAll('.t4s-product-colors a.bg_color_limit4s:not([aria-label])').forEach(function (link) {
      var group = link.closest('.t4s-product-colors');
      var label = group.getAttribute('data-more-colours-label');
      if (label) link.setAttribute('aria-label', label);
    });
  }
  function startColourLabels() {
    labelColourLinks();
    var main = document.getElementById('MainContent');
    if (main) new MutationObserver(labelColourLinks).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startColourLabels, { once: true });
  else startColourLabels();
})();
  } catch(e) { console.error(e); }
})();

})();
